import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { ApplicationState } from './store';

export interface IProtectedRouteProps extends RouteProps {
  showMenu: boolean;
}

const ProtectedRoute: React.FC<IProtectedRouteProps> = props => {
  const isLoggedIn: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn
  );

  return isLoggedIn ? (
    props.showMenu ? (
      <Route {...props} component={props.component} render={undefined} />
    ) : null
  ) : (
    <Redirect to="/" />
  );
};

export default ProtectedRoute;
